import React from 'react'
import { Route, Routes } from 'react-router-dom'
import BillList from './BillList'
import NewBill from './NewBill'
import EditBill from './EditBill'
import ViewBill from './ViewBill'

export default function BillRoute() {
  return (
    <Routes>
            <Route path="/" element={<BillList />} />
            <Route path="/new" element={<NewBill />} />
            <Route path="/edit/:id" element={<EditBill />} />
            <Route path="/view/:id" element={<ViewBill />} />  
    </Routes>
  )
}
